import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

export const PostDetailsWrapper = styled.div`
  position: relative;

  &.image_left {
    @media (min-width: 991px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-start;
    }
    .post_preview {
      margin-top: 0;
      @media (min-width: 991px) {
        flex: 0 0 42%;
        max-width: 42%;
        padding-right: 60px;
        margin: 0;
        &:before {
          width: calc(80% - 60px);
        }
      }
    }
    .post_des_wrapper {
      @media (min-width: 991px) {
        flex: 0 0 58%;
        max-width: 58%;
        margin: 0;
      }
      .post_des {
        margin-top: 60px;
      }
    }
  }
`;

export const PostTitle = styled.h1`
  font-size: 30px;
  font-weight: 700;
  color: ${themeGet("colors.textColor", "#292929")};
  line-height: 1.53;
  margin-bottom: 10px;
  @media (max-width: 1200px) {
    font-size: 26px;
    margin-bottom: 15px;
  }
  @media (max-width: 990px) {
    font-size: 24px;
    margin-bottom: 15px;
  }
  @media (max-width: 575px) {
    font-size: 20px;
    margin-bottom: 15px;
  }
`;

export const PostDate = styled.span`
  display: block;
  font-size: ${themeGet("fontSizes.3", "15")}px;
  color: ${themeGet("textColor", "#292929")};
  font-weight: 400;
  text-transform: uppercase;
  @media (max-width: 990px) {
    font-size: 14px;
  }
  @media (max-width: 575px) {
    font-size: 13px;
  }
`;

export const PostPreview = styled.div`
  margin-top: 45px;
  position: relative;
  @media (max-width: 1200px) {
    margin-top: 40px;
  }
  @media (max-width: 575px) {
    margin-top: 35px;
  }

  img {
    border-radius: 3px;
  }

  &:before {
    content: "";
    position: absolute;
    width: 80%;
    height: 80%;
    background-color: #757575;
    bottom: 0;
    left: 10%;
    filter: blur(15px);
  }
`;

export const PostDescriptionWrapper = styled.div`
  margin-top: 90px;
  margin-left: auto;
  margin-right: auto;
  width: 870px;
  max-width: 100%;

  @media (max-width: 1200px) {
    margin-top: 70px;
  }
  @media (max-width: 575px) {
    margin-top: 30px;
  }
`;

export const PostDescription = styled.div`
  font-size: ${themeGet("fontSizes.4", "16")}px;

  .mermaid {
    margin-bottom: 60px;
    @media (max-width: 767px) {
      margin-bottom: 40px;
    }
  }
  /* code[class*="language-text"] {
        color: black !important;
        text-shadow: none !important;
        font-family: 'Poppins',sans-serif !important;
  } */
  code[class*="language-"] {
    text-shadow: 0 1px #222245;
    color: #9efeff;
  }
  code[class*="language-text"] {
    text-shadow:none !important;
    /* color: black; */
  }
  /* pre[class*="language-"] {
    color: #9efeff;
    direction: ltr;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;

    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;

    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;

    font-family: "Operator Mono";
    font-weight: 400;
    font-size: 17px;
    line-height: 25px;
    letter-spacing: 0.5px;
    text-shadow: 0 1px #222245;
  } */
  .gatsby-code-button-container {
  touch-action: none;
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: 28px;
  right: 3px;
  z-index: 100;
  pointer-events: none;
}

.gatsby-code-button-icon {
  position: absolute;
    top: 30px;
    right: 10px;
  width: 14px;
  height: 14px;
  fill: gray;
}
  pre[class*="language-"]::-moz-selection,
  pre[class*="language-"] ::-moz-selection,
  code[class*="language-"]::-moz-selection,
  code[class*="language-"] ::-moz-selection,
  pre[class*="language-"]::selection,
  pre[class*="language-"] ::selection,
  code[class*="language-"]::selection,
  code[class*="language-"] ::selection {
    color: inherit;
    background: #a599e9;
  }

  :not(pre) > code[class*="language-"],
  pre[class*="language-"] {
    border-radius: 10px;
    background: #1e1e3f !important;
  }

  /* Inline code */
  :not(pre) > code[class*="language-"] {
    padding: 0.1em;
    border-radius: 0.3em;
  }

  .token {
    font-weight: 400;
  }

  .token.comment,
  .token.prolog,
  .token.cdata {
    color: #b362ff;
  }

  .token.delimiter,
  .token.keyword,
  .token.selector,
  .token.important,
  .token.atrule {
    color: #ff9d00;
  }

  .token.operator,
  .token.attr-name {
    color: rgb(255, 180, 84);
  }

  .token.punctuation {
    color: #ffffff;
  }

  .token.boolean {
    color: rgb(255, 98, 140);
  }

  .token.tag,
  .token.tag .punctuation,
  .token.doctype,
  .token.builtin {
    color: rgb(255, 157, 0);
  }

  .token.entity,
  .token.symbol {
    color: #6897bb;
  }

  .token.number {
    color: #ff628c;
  }

  .token.property,
  .token.constant,
  .token.variable {
    color: #ff628c;
  }

  .token.string,
  .token.char {
    color: #a5ff90;
  }

  .token.attr-value,
  .token.attr-value .punctuation {
    color: #a5c261;
  }

  .token.attr-value .punctuation:first-child {
    color: #a9b7c6;
  }

  .token.url {
    color: #287bde;
    text-decoration: underline;
  }

  .token.function {
    color: rgb(250, 208, 0);
  }

  .token.regex {
    background: #364135;
  }

  .token.bold {
    font-weight: bold;
  }

  .token.italic {
    font-style: italic;
  }

  .token.inserted {
    background: #00ff00;
  }

  .token.deleted {
    background: #ff000d;
  }

  code.language-css .token.property,
  code.language-css .token.property + .token.punctuation {
    color: #a9b7c6;
  }

  code.language-css .token.id {
    color: #ffc66d;
  }

  code.language-css .token.selector > .token.class,
  code.language-css .token.selector > .token.attribute,
  code.language-css .token.selector > .token.pseudo-class,
  code.language-css .token.selector > .token.pseudo-element {
    color: #ffc66d;
  }

  .token.class-name {
    color: #fb94ff;
  }

  .token.operator,
  .token.entity,
  .token.url,
  .language-css .token.string,
  .style .token.string {
    background: none;
  }

  pre .line-highlight,
  pre .line-highlight.line-highlight,
  pre > code.line-highlight {
    margin-top: 36px;
    background: linear-gradient(
      to right,
      rgba(179, 98, 255, 0.17),
      transparent
    );
  }

  pre .line-highlight:before,
  pre > code.line-highlight:before,
  pre .line-highlight[data-end]:after,
  pre > code.line-highlight[data-end]:after {
    content: "";
  }
  [data-language="js"]::before {
    position: relative;
    top: 40px;
    right: 10px;
    content: "JS";
    padding: 5px;
    border-radius: 10px;
    background-color: ${themeGet("colors.js", "red")};
  }
  [data-language="shell"]::before {
    position: relative;
    top: 40px;
    right: 10px;
    content: "SHELL";
    padding: 5px;
    color: white;
    border-radius: 10px;
    background-color: ${themeGet("colors.shell", "red")};
  }
  [data-language="go"]::before {
    position: relative;
    top: 40px;
    right: 10px;
    content: "GO";
    padding: 5px;
    color: white;
    border-radius: 10px;
    background-color: ${themeGet("colors.go", "red")};
  }
  code[class*="language-text"]{
    color: black !important;
  }
  [data-language="html"]::before {
    position: relative;
    top: 40px;
    right: 10px;
    content: "HTML";
    padding: 5px;
    color: white;
    border-radius: 10px;
    background-color: ${themeGet("colors.html", "red")};
  }
  [data-language="jsx"]::before {
    position: relative;
    top: 40px;
    right: 10px;
    content: "JSX";
    color: white;
    padding: 5px;
    border-radius: 10px;
    background-color: ${themeGet("colors.jsx", "red")};
  }
  [data-language="ts"]::before {
    position: relative;
    top: 40px;
    right: 10px;
    color: white;
    content: "TS";
    padding: 5px;
    border-radius: 10px;
    background-color: ${themeGet("colors.ts", "red")};
  }
  p {
    font-size: ${themeGet("fontSizes.4", "16")}px;
    margin-bottom: 2em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 500;
    margin-bottom: 0.75em;
  }

  h1 {
    font-size: 30px;
    margin-bottom: 0.75em;
  }

  h2 {
    font-size: 25px;
    margin-bottom: 0.75em;
  }

  h3 {
    font-size: 21px;
  }

  h4 {
    font-size: 17px;
  }

  h5 {
    font-size: 15px;
  }

  h6 {
    font-size: 13px;
  }

  ol,
  ul {
    margin-left: 1.5rem;
    margin-bottom: 2rem;
    line-height: 2;
  }

  li {
    margin-bottom: 0.45rem;

    p {
      margin-bottom: 1em;
    }
  }

  blockquote {
    font-family: "Poppins", sans-serif;
    font-size: 21px;
    font-weight: 500;
    line-height: 2;
    margin: 60px 0;
    @media (max-width: 1200px) {
      margin: 50px 0;
      font-size: 19px;
    }
    @media (max-width: 575px) {
      margin: 40px 0;
      font-size: 15px;
    }
    &:before,
    &:after {
      content: "";
      width: 30px;
      height: 1px;
      display: block;
      background: #292929;
    }
    &:before {
      margin-bottom: 60px;
      @media (max-width: 1200px) {
        margin-bottom: 50px;
      }
      @media (max-width: 575px) {
        margin-bottom: 40px;
      }
    }
    &:after {
      margin-top: 60px;
      @media (max-width: 1200px) {
        margin-top: 50px;
      }
      @media (max-width: 575px) {
        margin-top: 40px;
      }
    }

    p {
      font-size: 21px;
      font-weight: 500;
      line-height: 2;
      margin-bottom: 23px;
      @media (max-width: 1200px) {
        font-size: 19px;
      }
      @media (max-width: 1200px) {
        font-size: 17px;
      }
      @media (max-width: 575px) {
        font-size: 15px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    h4 {
      font-size: 16px;
      margin: 0;
      font-family: "Fira Sans", sans-serif;
      font-weight: 400;
    }
  }

  a {
    font-weight: 500;
    transition: 0.15s ease-in-out;
    color: ${themeGet("primary", "#D10068")};
  }
`;

export const PostTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 60px;

  a {
    display: block;
    margin-right: 30px;
    font-size: 14px;
    font-weight: 400;
    color: ${themeGet("primary", "#D10068")};
  }
`;
